import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer, Zoom} from 'react-toastify';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <ToastContainer  autoClose={2000} transition={Zoom} closeButton={false} hideProgressBar={true}
className="foo" style={{ width: "fit-content", minWidth:"200px" }}
        
      />

  </React.StrictMode>
);

